import { render, staticRenderFns } from "./DotacaoConcatenada.vue?vue&type=template&id=5d524585&scoped=true"
import script from "./DotacaoConcatenada.vue?vue&type=script&lang=js"
export * from "./DotacaoConcatenada.vue?vue&type=script&lang=js"
import style0 from "./DotacaoConcatenada.vue?vue&type=style&index=0&id=5d524585&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d524585",
  null
  
)

export default component.exports